import React from 'react';
import {RenderCardElement } from '../../../localData/CardsData/RenderCardElement';
import {Container} from './BlogCard.Styles'
import { 
  useIsDesktopBig,
  useIsDesktopMedium,
  useIsDesktopOrLaptop, 
  useIsMiniNotebook, 
  useIsMobileBig, 
  useIsMobileMedium, 
  useIsMobileMini,
  } from '../../../styles/theme'

interface BlogCardProps {
    post: {
      date: string;
      routeCard: string;
      description: string;
      elements: Array<{
        type: string ;
        content: string | string[] | ElementType[]; // Ajuste isso se precisar ser mais específico
        getStyles?: (breakpoints: {
          isDesktopOrLaptop: boolean;
          isMiniNotebook: boolean;
          isIpadBig: boolean;
        }) => React.CSSProperties;
      }>;
    };
  }

  interface ElementType {
    type: string ;
    content: string | string[] | ElementType[]; // Ajuste para suportar listas ou elementos aninhados
    getStyles?: (breakpoints: {
      isDesktopOrLaptop: boolean;
      isMiniNotebook: boolean;
      isIpadBig: boolean;
    }) => React.CSSProperties;
  }
 

  export const BlogCard: React.FC<BlogCardProps> = ({ post }) => {
    React.useEffect(() => {
      // Define o título da página baseado no primeiro elemento, se for string
      if (typeof post.elements[0]?.content === 'string') {
        document.title = post.elements[0].content;
      }
  
      // Define ou atualiza a meta tag de descrição
      let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
      if (metaDescription) {
        metaDescription.content = post.description;
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = post.description;
        document.head.appendChild(metaDescription);
      }
    }, [post]);
  

  return (
    console.log('post post',post),
    <Container
      isMobileMini={useIsMobileMini()}
      isMobileMedium={useIsMobileMedium()}
      isMobileBig={useIsMobileBig()}
      isMiniNotebook={useIsMiniNotebook()}
      isDesktopOrLaptop={useIsDesktopOrLaptop()}
      isDesktopMedium={useIsDesktopMedium()}
      isDesktopBig={useIsDesktopBig()}
    >
      {post.elements.map((element, index) => (
        <RenderCardElement key={index} element={element} />
      ))}
      <p style={{ fontStyle: 'italic', color: '#999' }}>{post.date}</p>
    </Container>
  );
};

